import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';

const importBuilds = () => import(/* webpackChunkName: "builds" */ './containers/BuildContainer');

const BuildRoutes = ({ match }) => (
  <BundleRoute
    load={importBuilds}
    path={`${match.url}/:buildId`}
  />
);

BuildRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default BuildRoutes;
